import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { AppRoot } from '@telegram-apps/telegram-ui';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { initI18n } from '@/i18n';

// Initialize internationalization (loads persisted language, sets dir/lang)
initI18n();

// Global fallback for broken images (e.g. Telegram avatars failing due to CORS)
window.addEventListener('error', (e: any) => {
    if (e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'img') {
        const img = e.target as HTMLImageElement;
        if (!img.dataset.fallbackApplied) {
            img.dataset.fallbackApplied = 'true';
            // Use dicebear fallback if the avatar fails to load
            img.src = '/icons/default-avatar.svg';
        }
    }
}, true);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TonConnectUIProvider
      manifestUrl="https://modeapip.com/tonconnect-manifest.json"
      actionsConfiguration={{
        twaReturnUrl: 'https://t.me/JGHJYGFFTBOT/app'
      }}
    >
      <AppRoot appearance="dark">
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AppRoot>
    </TonConnectUIProvider>
  </React.StrictMode>,
)
